import expandMacros from "./macros";

let loader, lastLoaderState, lastLoaderMessage, loaderMessageQueue, loaderMessageInterval;
const loaderMessageSwapDelay = 1500; /* ms */

// Set loader element
document.addEventListener("DOMContentLoaded", () => {
  loader = document.querySelector(".loader");
});

/**
 * Changes the loader message
 *
 * @param message {String}
 */
const setLoaderMessage = (message) => {
  /* tuned for 150ms round trip */
  if (message === lastLoaderMessage) {
    return;
  }

  loader.querySelector(".loader__message").classList.remove("visible");
  setTimeout(function() {
    loader.querySelector(".loader__message").innerHTML = message;
    loader.querySelector(".loader__message").classList.add("visible");
    lastLoaderMessage = message;
  }, 150);
};

/**
 * Clears loader state (hides it and icons)
 */
const clearLoaderState = () => {
  loader.classList.remove("visible");
  loader.querySelector(".loader__message").classList.remove("visible");
  loader.querySelector(".icon__animating").classList.remove("visible");
  loader.querySelector(".icon__success").classList.remove("visible");
  loader.querySelector(".icon__error").classList.remove("visible");
  loader.querySelector(".icon__welcome").classList.remove("visible");
  lastLoaderState = null;
  lastLoaderMessage = null;
};

/**
 * Iterate through all messages in loader
 */
const iterateLoaderMessages = () => {
  clearInterval(loaderMessageInterval);
  if (loaderMessageQueue.length === 0) {
    return;
  }
  setLoaderMessage(expandMacros(loaderMessageQueue.shift()));
  loaderMessageInterval = setInterval(iterateLoaderMessages, loaderMessageSwapDelay);
};

/**
 * Show loader
 */
const showLoader = () => {
  loader.classList.add("open");
};

/**
 * Hide loader
 */
const hideLoader = () => {
  loader.classList.remove("open");
  clearLoaderState();
};

/**
 * Set loader state
 *
 * @param state {String}
 * @param messages {String[]}
 */
const setLoaderState = (state, messages) => {
  clearInterval(loaderMessageInterval);
  loaderMessageQueue = messages;
  iterateLoaderMessages();

  if (state === lastLoaderState) {
    return;
  }

  clearLoaderState();
  setTimeout(
    () => {
      loader.querySelector(".icon__" + state).classList.add("visible");
      lastLoaderState = state;
    },
    150,
  );
};

export {showLoader, hideLoader, setLoaderState};
